import React from 'react';

import DropdownCell from './select';
import DisplayCell from './display';
import InputCell from './input';

const paddingMap = {
	header: { x: '1.25rem', y: '0.4rem' },
	body: { x: '1.25rem', y: '1px' },
	none: { y: '1px' },
	halfBodyLeft: { l: '1.25rem', y: '1px' },
	halfBodyRight: { r: '1.25rem', y: '1px' },
};

/* eslint-disable react/prop-types,react/jsx-props-no-spreading */

function Cell({
	type,
	pad,
	backgroundColor,
	textAlign,
	textColor,
	textSize,
	textWeight,
	m,
	h,
	w,
	justify,
	maxW,
	minW,
	divStyle,
	DivPropsProp,
	TextPropsProp,
	...props
}) {
	const DivProps = {
		h,
		w,
		maxW,
		minW,
		m,
		p: paddingMap[pad],
		bg: backgroundColor,
		justify,
		style: divStyle,
		...DivPropsProp,
	};
	const TextProps = {
		textAlign,
		textColor,
		textSize,
		textWeight,
		...TextPropsProp,
	};
	if (type === 'input') return <InputCell InputProps={TextProps} DivProps={DivProps} {...props} />;
	if (type === 'select') return <DropdownCell DivProps={DivProps} {...props} />;
	return <DisplayCell TextProps={TextProps} DivProps={DivProps} {...props} />;
}

Cell.defaultProps = {
	format: null,
	formattingOptions: {},
	inputPath: '',
	inputValue: null,
	nextRef: null,
	onChange: () => {},
	prevRef: null,
	type: 'display',
	pad: 'body',
	textAlign: 'left',
	textColor: 'white',
	textSize: 'body',
	w: '100%',
	m: '0px',
	justify: 'end',
};

export default Cell;
/* eslint-enable */
